var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pageContainer"},[_c('h1',[_vm._v("News Feed")]),_c('post-tweet'),_c('all-tweets-follow')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }